import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { buildSiteForm } from './site-form-builder';
import { SiteDto } from '@app/admin/models/site-dto';
import { Store } from '@ngrx/store';
import { AddSite } from '@app/core/store/actions/site.action';

@Component({
  selector: 'app-add-location',
  templateUrl: './add-location.component.html',
  styleUrls: ['./add-location.component.scss'],
  standalone: false,
})
export class AddLocationComponent implements OnInit {
  form: UntypedFormGroup;

  constructor(
    formBuilder: UntypedFormBuilder,
    private dialogRef: MatDialogRef<AddLocationComponent>,
    private store: Store,
    private router: Router,
  ) {
    this.form = buildSiteForm(formBuilder);
  }

  ngOnInit(): void {}

  async onAdd() {
    const site = this.form.getRawValue() as SiteDto;

    this.store.dispatch(new AddSite(site));
    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close();
  }
}
